import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { addTransferPoint, editTransferPoint } from 'features/transportation/transportationSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { ITransferPoint } from 'types/api/transportationApi.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const TransferPointsModal = ({ closeModal, value }: { closeModal: any, value?: ITransferPoint }) => {
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)
    const [state, setState] = useState<ITransferPoint>(value || {
        name: '',
        address: ''
    })

    const handleSave = async () => {
        const resp = await dispatch(value?.id ? editTransferPoint(state) : addTransferPoint(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setState(prev => ({ ...prev, [name]: value }))
    }

    return <Modal black>
        <Flex column between center gap='1rem' >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Transfer Point</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Start, finish...' labelText='Name' name='name' value={state?.name} onChange={handleChange} nomarg />
                <Input placeholder='Main Street 123...' labelText='Address' name='address' value={state?.address} onChange={handleChange} nomarg />
            </Flex>
            <Button disabled={!state.address || !state.name} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}
